var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgL1CloudUnavailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.15 31.093C53.563 23.043 46.493 17 38 17c-3.453 0-6.65 1.003-9.357 2.73l3.407 3.407a12.758 12.758 0 015.95-1.47c7.093 0 12.833 5.74 12.833 12.833v1.167h3.5c3.874 0 7 3.126 7 7 0 2.636-1.493 4.923-3.64 6.113l3.384 3.383C64.04 50.04 66 46.587 66 42.667c0-6.16-4.783-11.154-10.85-11.574zM17 19.963l6.417 6.394C15.973 26.683 10 32.797 10 40.333c0 7.724 6.277 14 14 14h27.37L56.037 59 59 56.037 19.963 17 17 19.963zM28.037 31l18.666 18.667H24a9.33 9.33 0 01-9.333-9.334A9.33 9.33 0 0124 31h4.037z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/L1_Cloud_unavailable.04fc8c90.svg";
export { SvgL1CloudUnavailable as ReactComponent };